// extracted by mini-css-extract-plugin
export default {"wrapper":"NotesList_wrapper__dxUtJ","container":"NotesList_container__S1Z9V","SavedNotesText":"NotesList_SavedNotesText__859Bc"};